import { updateKeyInStore } from 'App';
import { updateKey } from '../slice';

import { fields } from '../fields';

type UploadFields = typeof fields;

export const uploadFields: UploadFields = [
  {
    name: 'youCanUploadAnExcelSpreadsheetContainingTheInformationRegardingRentalExpensesInsteadOfCompletingBelow',
    label:
      'You can upload an Excel spreadsheet containing the information regarding rental expenses instead of completing below',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
];
